import React from "react";

function Avatar({ profileImageUrl, name }) {
  const generateAvatar = (initial) => {
    const colors = ["FFC107", "E91E63", "2196F3", "4CAF50", "9C27B0"];
    const randomColor = colors[Math.floor(Math.random() * colors.length)];
    return `https://via.placeholder.com/25/${randomColor}/FFFFFF?text=${initial}`;
  };

  const avatarSrc = profileImageUrl || generateAvatar(name);

  return (
    <img
      src={avatarSrc}
      alt="Profile"
      className="avatar avatar-xs me-2"
    />
  );
}

export default Avatar;
